import { render, staticRenderFns } from "./close-toast.vue?vue&type=template&id=1bc15f8f&scoped=true&"
import script from "./close-toast.vue?vue&type=script&lang=js&"
export * from "./close-toast.vue?vue&type=script&lang=js&"
import style0 from "./close-toast.vue?vue&type=style&index=0&id=1bc15f8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc15f8f",
  null
  
)

export default component.exports